import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82b8ebf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-div" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column is-one-third-desktop is-offset-one-third-desktop" }
const _hoisted_5 = { class: "is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://i.imgur.com/uA3fRLZ.png",
    class: "image",
    alt: "logo"
  })
], -1))
const _hoisted_7 = {
  key: 0,
  class: "is-flex is-flex-direction-column is-justify-content-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("progress", { class: "progress is-primary" }, null, -1))
const _hoisted_9 = {
  key: 1,
  class: "is-flex is-flex-direction-column is-align-content-center"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5 has-text-centered" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-times has-text-danger fa-6x" })
], -1))
const _hoisted_11 = { class: "is-size-5 has-text-centered" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "control" }
const _hoisted_14 = {
  key: 2,
  class: "mt-5"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-check has-text-success fa-6x" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 3,
  class: "mt-5 has-text-centered"
}
const _hoisted_18 = { class: "is-size-3" }
const _hoisted_19 = { class: "is-size-5" }
const _hoisted_20 = { class: "has-text-grey" }
const _hoisted_21 = { class: "control" }

import { useRouter, useRoute } from 'vue-router';
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { Notyf } from "notyf";
import { useI18n } from 'vue-i18n';
import { onBeforeMount } from 'vue';
import { changeLocale } from "@/main"; // Import the changeLocale function

interface ConfirmPaymentParams {
    payment_hash: string,
    language: string
}



const __default__ = {
  name: "RequestConfirmed",
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


const router = useRouter();
const route = useRoute()
const store = useStore()
const { locale } = useI18n();
const paymentHash = ref()
const validating = ref(true)
const hasError = ref(false)
const notyf = new Notyf()
const lang = route.query.lang as string;

const goToCustomerDataMeth = async ($t : any) => {
  const token = localStorage.getItem('token') || ''
  const userData = JSON.parse(localStorage.getItem('userData') || '{}')
  
  if((token == '') || (userData == '{}'))
  {
    notyf.error($t('General.NotyfInvalidAccess'))
    //router.push({ path: "/", query: { lang: locale.value } });
    router.push("/");
  }
  else
  {
    if(userData.type == "customer")
    {
      const loginData = await store.dispatch('IniAccessType', userData.type)
      //router.push({ path: "/" + store.getters['getAccessType'], query: { lang: locale.value } });
      router.push("/" + store.getters['getAccessType']);
    }
    else
    {
      notyf.error($t('General.NotyfInvalidAccess'))
      //router.push({ path: "/", query: { lang: locale.value } });
      router.push("/");
    }
  }
};

onBeforeMount(async() => {

  if (lang)
  {
    try
    {
      await changeLocale(lang);
    }
    catch (error)
    {
      console.error('Failed to change language:', error);
    }
  }

})

onMounted(async () => {

  //paymentHash.value = route.params.payment_hash
  const confirmPaymentParams: ConfirmPaymentParams = {
    payment_hash: route.query.paymentHash as string,
    language: lang
  }

  /* validate payment */
  try {
    const validated = await store.dispatch('confirmPayment', confirmPaymentParams)

    /* turn off validation state */
    if (validated) {
      validating.value = false
    }/* turn off validation state */
    if (validated) {
      validating.value = false
    }
  } catch (e) {
    hasError.value = true
  }


})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            (validating.value && !hasError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('Customer.WaitForConfirmation')), 1),
                  _hoisted_8
                ]))
              : _createCommentVNode("", true),
            (hasError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('Customer.PaymentProblem')), 1),
                  _createElementVNode("p", {
                    class: "has-text-grey has-text-centered",
                    innerHTML: _ctx.$t('Customer.ContactSupport')
                  }, null, 8, _hoisted_12),
                  _createElementVNode("p", _hoisted_13, [
                    _createElementVNode("a", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (goToCustomerDataMeth(_ctx.$t))),
                      class: "button is-light"
                    }, _toDisplayString(_ctx.$t('General.OK')), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (!validating.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
              : _createCommentVNode("", true),
            (!validating.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('General.ThankYou')), 1),
                  _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('Customer.ScheduleConfirmed')), 1),
                  _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t('Customer.ScheduleConfirmedNote')), 1),
                  _createVNode(_component_router_link, { to: "/meeting" }),
                  _createElementVNode("p", _hoisted_21, [
                    _createElementVNode("a", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (goToCustomerDataMeth(_ctx.$t))),
                      class: "button is-light"
                    }, _toDisplayString(_ctx.$t('General.OK')), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})